import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { Selectorispogzpkkfxv as Selector } from './Selector.mjs';
import { Checkbox2he0oy51inwu6 as Checkbox } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Checkbox.commonHtml.mjs';
import { ensureOutermostElement1f4fzdv7yw0ql as ensureOutermostElement } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/NativeElement.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { TextViewe6rp77b08kos as TextView } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/TextView.commonHtml.mjs';
import { KMutableProperty025txtn5b59pq1 as KMutableProperty0 } from '../../../../../kotlin-kotlin-stdlib/kotlin/reflect/KPropertyJs.mjs';
import {
  TextView$_get_content_$ref_4pzcwl1tl9xt9sj2eem as TextView$_get_content_$ref_4pzcwl,
  TextView$_set_content_$ref_pketfbq6gzmblx5q7v as TextView$_set_content_$ref_pketfb,
} from '../auth/EmailProofComponent.mjs';
import { getPropertyCallableRef3hckxc0xueiaj as getPropertyCallableRef } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import { RowOrCol3a33s3yce2tuv as RowOrCol } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/LinearLayouts.commonHtml.mjs';
import { get_centered31th09q7x90sf as get_centered } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/helpers.mjs';
import { text189ciz0cnr32o as text } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/shortcuts.mjs';
import { textPopover3tarprbgmgxbr as textPopover } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/modifiers.commonHtml.mjs';
import {
  Companion_getInstance23x6zslwzj0st as Companion_getInstance,
  Align_End_getInstancer37lklmdzqms as Align_End_getInstance,
} from '../../../../../kiteui-library/com/lightningkite/kiteui/models/data.mjs';
import { get_rem2p56fiaxda5jo as get_rem } from '../../../../../kiteui-library/com/lightningkite/kiteui/models/data.commonHtml.mjs';
import { IconView32wln42r1v8cb as IconView } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/IconView.commonHtml.mjs';
import {
  priority2y7gf37j4tged as priority,
  cellView255m1dxiud5di as cellView,
  Renderer1fhwti5gmwutm as Renderer,
  labeledForm2ame2d0a5lql9 as labeledForm,
  labeledView3rpvir7z2o9ii as labeledView,
  cellFormub3o1hqp20e5 as cellForm,
} from './Renderer.mjs';
import { protoOf180f3jzyo7rfj as protoOf } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { initMetadataForObject1cxne3s9w65el as initMetadataForObject } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { noWhenBranchMatchedException2a6r7ubxgky5j as noWhenBranchMatchedException } from '../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { FieldSemantic_getInstancer1p3l15xmphu as FieldSemantic_getInstance } from '../../../../../kiteui-library/com/lightningkite/kiteui/models/Theme.mjs';
import { themed2vu67ornd4jps as themed } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/themeDerivations.mjs';
import { Select2osqjs95yxuh6 as Select } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Select.commonHtml.mjs';
import { listOf1jh22dvmctj1r as listOf } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/CollectionsKt.mjs';
import {
  _Constant___init__impl__v45mub2qfk15kh5l39c as _Constant___init__impl__v45mub,
  Constant3smypj7m9af27 as Constant,
} from '../../../../../reactive/com/lightningkite/reactive/core/signals.mjs';
import {
  get_isMultiline1iipzhzq60rsb as get_isMultiline,
  get_hint19r2vwwyh0jr3 as get_hint,
  get_averageLength8laoo3shoyld as get_averageLength,
} from './Annotations.mjs';
import { TextInput22lgsa81snd26 as TextInput } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/TextField.commonHtml.mjs';
import {
  coerceAtMost322komnqp70ag as coerceAtMost,
  coerceAtLeastklytehohcpeq as coerceAtLeast,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/ranges/_Ranges.mjs';
import { TextArea6va0jt1dj0tc as TextArea } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/TextArea.commonHtml.mjs';
import { _Char___init__impl__6a9atxrzocepzq3zgi as _Char___init__impl__6a9atx } from '../../../../../kotlin-kotlin-stdlib/kotlin/Char.mjs';
import { substringBefore3n7kj60w69hju as substringBefore } from '../../../../../kotlin-kotlin-stdlib/kotlin/text/Strings.mjs';
import { numberToInt1ygmcfwhs2fkq as numberToInt } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/numberConversion.mjs';
import { NumberInput16nzuc28fuw7p as NumberInput } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/NumberField.commonHtml.mjs';
import {
  toNumber2e2hj9zugjwi2 as toNumber,
  numberToLong2pakxeg38estk as numberToLong,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/internal/longAsBigInt/longAsBigInt.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function registerPrimitives(_this__u8e3s4) {
  _this__u8e3s4.register_9awv9l_k$(new (Selector())(VOID, 'kotlin.Boolean'), BooleanRenderer_instance);
  _this__u8e3s4.register_9awv9l_k$(new (Selector())(VOID, 'kotlin.Boolean?'), NullableBooleanRenderer_instance);
  _this__u8e3s4.register_9awv9l_k$(new (Selector())(VOID, 'kotlin.String'), StringRenderer_instance);
  var tmp0_annotation = 'com.lightningkite.services.data.Multiline';
  _this__u8e3s4.register_9awv9l_k$(new (Selector())(tmp0_annotation, 'kotlin.String'), MultilineStringRenderer_instance);
  _this__u8e3s4.register_9awv9l_k$(new (Selector())(VOID, 'kotlin.Int'), IntRenderer_instance);
  _this__u8e3s4.register_9awv9l_k$(new (Selector())(VOID, 'kotlin.Int?'), NullableIntRenderer_instance);
  _this__u8e3s4.register_9awv9l_k$(new (Selector())(VOID, 'kotlin.Long'), LongRenderer_instance);
  _this__u8e3s4.register_9awv9l_k$(new (Selector())(VOID, 'kotlin.Long?'), NullableLongRenderer_instance);
  _this__u8e3s4.register_9awv9l_k$(new (Selector())(VOID, 'kotlin.Double'), DoubleRenderer_instance);
  _this__u8e3s4.register_9awv9l_k$(new (Selector())(VOID, 'kotlin.Double?'), NullableDoubleRenderer_instance);
}
var BooleanRendererClass;
function BooleanRenderer() {
  if (BooleanRendererClass === VOID) {
    class $ {
      constructor() {
        this.name_1 = 'Checkbox';
      }
      get_name_woqyms_k$() {
        return this.name_1;
      }
      form_ot0i9m_k$(context, value, module_0) {
        return (_this__u8e3s4) => {
          // Inline function 'com.lightningkite.kiteui.views.direct.checkbox' call
          // Inline function 'com.lightningkite.kiteui.views.write' call
          var element = new (Checkbox())(_this__u8e3s4.get_context_h02k06_k$());
          ensureOutermostElement(element);
          _this__u8e3s4.willAddChild_hz2iwc_k$(element);
          element.bind_gesskf_k$(element.checked_1, value);
          element.onStartup_vrxh3i_k$();
          _this__u8e3s4.addChild_2qpft2_k$(element);
          return Unit_instance;
        };
      }
      form_gie6yk_k$(context, value, module_0) {
        return this.form_ot0i9m_k$(context, value, module_0);
      }
      view_maotgz_k$(context, value, module_0) {
        return (_this__u8e3s4) => {
          // Inline function 'com.lightningkite.kiteui.views.direct.text' call
          // Inline function 'com.lightningkite.kiteui.views.write' call
          var element = new (TextView())(_this__u8e3s4.get_context_h02k06_k$());
          ensureOutermostElement(element);
          _this__u8e3s4.willAddChild_hz2iwc_k$(element);
          var tmp = KMutableProperty0();
          var tmp_0 = TextView$_get_content_$ref_4pzcwl(element);
          var tmp_1 = getPropertyCallableRef('content', 0, tmp, tmp_0, TextView$_set_content_$ref_pketfb(element));
          element.invoke_bnq13k_k$(tmp_1, ($this$invoke) => $this$invoke.invoke_r7m7el_k$(value) ? '\u2713' : '\u2717');
          element.onStartup_vrxh3i_k$();
          _this__u8e3s4.addChild_2qpft2_k$(element);
          return Unit_instance;
        };
      }
      view_bqdmap_k$(context, value, module_0) {
        return this.view_maotgz_k$(context, value, module_0);
      }
      cellForm_7pu4c_k$(context, value, module_0) {
        return this.form_ot0i9m_k$(context, value, module_0);
      }
      cellForm_4mayde_k$(context, value, module_0) {
        return this.cellForm_7pu4c_k$(context, value, module_0);
      }
      columnWidth_h3u0lu_k$(context, module_0) {
        return 3.0;
      }
      columnWidth_ilfqwj_k$(context, module_0) {
        return this.columnWidth_h3u0lu_k$(context, module_0);
      }
      labeledForm_c2erds_k$(context, value, module_0, label, description) {
        return (_this__u8e3s4) => {
          // Inline function 'com.lightningkite.kiteui.views.direct.row' call
          // Inline function 'com.lightningkite.kiteui.views.write' call
          var element = new (RowOrCol())(_this__u8e3s4.get_context_h02k06_k$());
          ensureOutermostElement(element);
          _this__u8e3s4.willAddChild_hz2iwc_k$(element);
          element.set_vertical_nuap32_k$(false);
          // Inline function 'com.lightningkite.kiteui.views.direct.checkbox' call
          var this_0 = get_centered(element);
          // Inline function 'com.lightningkite.kiteui.views.write' call
          var element_0 = new (Checkbox())(this_0.get_context_h02k06_k$());
          ensureOutermostElement(element_0);
          this_0.willAddChild_hz2iwc_k$(element_0);
          element_0.bind_gesskf_k$(element_0.checked_1, value);
          element_0.onStartup_vrxh3i_k$();
          this_0.addChild_2qpft2_k$(element_0);
          text(get_centered(element), label);
          var tmp0_safe_receiver = description;
          if (tmp0_safe_receiver == null)
            null;
          else {
            // Inline function 'kotlin.let' call
            var tmp0 = textPopover(get_centered(element), tmp0_safe_receiver);
            // Inline function 'com.lightningkite.kiteui.views.direct.icon' call
            var icon = Companion_getInstance().info_1.copy$default_cqy5mq_k$(get_rem(1), get_rem(1));
            // Inline function 'com.lightningkite.kiteui.views.direct.icon' call
            // Inline function 'com.lightningkite.kiteui.views.write' call
            var element_1 = new (IconView())(tmp0.get_context_h02k06_k$());
            ensureOutermostElement(element_1);
            tmp0.willAddChild_hz2iwc_k$(element_1);
            element_1.set_source_3o5lkf_k$(icon);
            element_1.set_description_s1386w_k$('Info');
            element_1.onStartup_vrxh3i_k$();
            tmp0.addChild_2qpft2_k$(element_1);
          }
          element.onStartup_vrxh3i_k$();
          _this__u8e3s4.addChild_2qpft2_k$(element);
          return Unit_instance;
        };
      }
      labeledForm_ughtr2_k$(context, value, module_0, label, description) {
        return this.labeledForm_c2erds_k$(context, value, module_0, label, description);
      }
      labeledView_59ut1v_k$(context, value, module_0, label, description) {
        return (_this__u8e3s4) => {
          // Inline function 'com.lightningkite.kiteui.views.direct.row' call
          // Inline function 'com.lightningkite.kiteui.views.write' call
          var element = new (RowOrCol())(_this__u8e3s4.get_context_h02k06_k$());
          ensureOutermostElement(element);
          _this__u8e3s4.willAddChild_hz2iwc_k$(element);
          element.set_vertical_nuap32_k$(false);
          // Inline function 'com.lightningkite.kiteui.views.direct.text' call
          var this_0 = get_centered(element);
          // Inline function 'com.lightningkite.kiteui.views.write' call
          var element_0 = new (TextView())(this_0.get_context_h02k06_k$());
          ensureOutermostElement(element_0);
          this_0.willAddChild_hz2iwc_k$(element_0);
          var tmp = KMutableProperty0();
          var tmp_0 = TextView$_get_content_$ref_4pzcwl(element_0);
          var tmp_1 = getPropertyCallableRef('content', 0, tmp, tmp_0, TextView$_set_content_$ref_pketfb(element_0));
          element_0.invoke_bnq13k_k$(tmp_1, ($this$invoke) => $this$invoke.invoke_r7m7el_k$(value) ? '\u2713' : '\u2717');
          element_0.onStartup_vrxh3i_k$();
          this_0.addChild_2qpft2_k$(element_0);
          text(get_centered(element), label);
          var tmp0_safe_receiver = description;
          if (tmp0_safe_receiver == null)
            null;
          else {
            // Inline function 'kotlin.let' call
            var tmp0 = textPopover(get_centered(element), tmp0_safe_receiver);
            // Inline function 'com.lightningkite.kiteui.views.direct.icon' call
            var icon = Companion_getInstance().info_1.copy$default_cqy5mq_k$(get_rem(1), get_rem(1));
            // Inline function 'com.lightningkite.kiteui.views.direct.icon' call
            // Inline function 'com.lightningkite.kiteui.views.write' call
            var element_1 = new (IconView())(tmp0.get_context_h02k06_k$());
            ensureOutermostElement(element_1);
            tmp0.willAddChild_hz2iwc_k$(element_1);
            element_1.set_source_3o5lkf_k$(icon);
            element_1.set_description_s1386w_k$('Info');
            element_1.onStartup_vrxh3i_k$();
            tmp0.addChild_2qpft2_k$(element_1);
          }
          element.onStartup_vrxh3i_k$();
          _this__u8e3s4.addChild_2qpft2_k$(element);
          return Unit_instance;
        };
      }
      labeledView_aldyvt_k$(context, value, module_0, label, description) {
        return this.labeledView_59ut1v_k$(context, value, module_0, label, description);
      }
    }
    protoOf($).priority_yxj3hb_k$ = priority;
    protoOf($).cellView_2dvin1_k$ = cellView;
    initMetadataForObject($, 'BooleanRenderer', VOID, VOID, [Renderer()]);
    BooleanRendererClass = $;
  }
  return BooleanRendererClass;
}
var BooleanRenderer_instance;
function BooleanRenderer_getInstance() {
  return BooleanRenderer_instance;
}
function NullableBooleanRenderer$form$lambda$lambda(it) {
  var tmp;
  switch (it) {
    case true:
      tmp = 'Yes';
      break;
    case false:
      tmp = 'No';
      break;
    case null:
      tmp = 'N/A';
      break;
    default:
      noWhenBranchMatchedException();
      break;
  }
  return tmp;
}
var NullableBooleanRendererClass;
function NullableBooleanRenderer() {
  if (NullableBooleanRendererClass === VOID) {
    class $ {
      constructor() {
        this.name_1 = 'Yes/No/N/A';
      }
      get_name_woqyms_k$() {
        return this.name_1;
      }
      form_6qbz4s_k$(context, value, module_0) {
        return (_this__u8e3s4) => {
          // Inline function 'com.lightningkite.kiteui.views.fieldTheme' call
          // Inline function 'com.lightningkite.kiteui.views.direct.select' call
          var this_0 = themed(_this__u8e3s4, FieldSemantic_getInstance());
          // Inline function 'com.lightningkite.kiteui.views.write' call
          var element = new (Select())(this_0.get_context_h02k06_k$());
          ensureOutermostElement(element);
          this_0.willAddChild_hz2iwc_k$(element);
          var tmp = _Constant___init__impl__v45mub(listOf([null, true, false]));
          element.bind_64a41i_k$(value, new (Constant())(tmp), NullableBooleanRenderer$form$lambda$lambda);
          element.onStartup_vrxh3i_k$();
          this_0.addChild_2qpft2_k$(element);
          return Unit_instance;
        };
      }
      form_gie6yk_k$(context, value, module_0) {
        return this.form_6qbz4s_k$(context, value, module_0);
      }
      view_u332zl_k$(context, value, module_0) {
        return (_this__u8e3s4) => {
          // Inline function 'com.lightningkite.kiteui.views.direct.text' call
          // Inline function 'com.lightningkite.kiteui.views.write' call
          var element = new (TextView())(_this__u8e3s4.get_context_h02k06_k$());
          ensureOutermostElement(element);
          _this__u8e3s4.willAddChild_hz2iwc_k$(element);
          var tmp = KMutableProperty0();
          var tmp_0 = TextView$_get_content_$ref_4pzcwl(element);
          var tmp_1 = getPropertyCallableRef('content', 0, tmp, tmp_0, TextView$_set_content_$ref_pketfb(element));
          element.invoke_bnq13k_k$(tmp_1, ($this$invoke) => {
            var tmp;
            switch ($this$invoke.invoke_r7m7el_k$(value)) {
              case true:
                tmp = '\u2713';
                break;
              case false:
                tmp = '\u2717';
                break;
              case null:
                tmp = '\u2014';
                break;
              default:
                noWhenBranchMatchedException();
                break;
            }
            return tmp;
          });
          element.onStartup_vrxh3i_k$();
          _this__u8e3s4.addChild_2qpft2_k$(element);
          return Unit_instance;
        };
      }
      view_bqdmap_k$(context, value, module_0) {
        return this.view_u332zl_k$(context, value, module_0);
      }
      cellForm_rizo0u_k$(context, value, module_0) {
        return this.form_6qbz4s_k$(context, value, module_0);
      }
      cellForm_4mayde_k$(context, value, module_0) {
        return this.cellForm_rizo0u_k$(context, value, module_0);
      }
      columnWidth_n22j19_k$(context, module_0) {
        return 5.0;
      }
      columnWidth_ilfqwj_k$(context, module_0) {
        return this.columnWidth_n22j19_k$(context, module_0);
      }
    }
    protoOf($).priority_yxj3hb_k$ = priority;
    protoOf($).cellView_2dvin1_k$ = cellView;
    protoOf($).labeledForm_ughtr2_k$ = labeledForm;
    protoOf($).labeledView_aldyvt_k$ = labeledView;
    initMetadataForObject($, 'NullableBooleanRenderer', VOID, VOID, [Renderer()]);
    NullableBooleanRendererClass = $;
  }
  return NullableBooleanRendererClass;
}
var NullableBooleanRenderer_instance;
function NullableBooleanRenderer_getInstance() {
  return NullableBooleanRenderer_instance;
}
var StringRendererClass;
function StringRenderer() {
  if (StringRendererClass === VOID) {
    class $ {
      constructor() {
        this.name_1 = 'Text';
      }
      get_name_woqyms_k$() {
        return this.name_1;
      }
      priority_splaix_k$(context, module_0) {
        return get_isMultiline(context) ? 0.5 : 1.0;
      }
      priority_yxj3hb_k$(context, module_0) {
        return this.priority_splaix_k$(context, module_0);
      }
      form_xfigbc_k$(context, value, module_0) {
        return (_this__u8e3s4) => {
          // Inline function 'com.lightningkite.kiteui.views.fieldTheme' call
          // Inline function 'com.lightningkite.kiteui.views.direct.textInput' call
          var this_0 = themed(_this__u8e3s4, FieldSemantic_getInstance());
          // Inline function 'com.lightningkite.kiteui.views.write' call
          var element = new (TextInput())(this_0.get_context_h02k06_k$());
          ensureOutermostElement(element);
          this_0.willAddChild_hz2iwc_k$(element);
          element.bind_gesskf_k$(element.content_1, value);
          var tmp0_safe_receiver = get_hint(context);
          if (tmp0_safe_receiver == null)
            null;
          else {
            // Inline function 'kotlin.let' call
            // Inline function 'com.lightningkite.kiteui.views.direct.TextInput.hint' call
            // Inline function 'com.lightningkite.kiteui.views.placeholder' call
            element.native_1.attributes_1.native_1.placeholder = tmp0_safe_receiver;
          }
          element.onStartup_vrxh3i_k$();
          this_0.addChild_2qpft2_k$(element);
          return Unit_instance;
        };
      }
      form_gie6yk_k$(context, value, module_0) {
        return this.form_xfigbc_k$(context, value, module_0);
      }
      view_9k7335_k$(context, value, module_0) {
        return (_this__u8e3s4) => {
          // Inline function 'com.lightningkite.kiteui.views.direct.text' call
          // Inline function 'com.lightningkite.kiteui.views.write' call
          var element = new (TextView())(_this__u8e3s4.get_context_h02k06_k$());
          ensureOutermostElement(element);
          _this__u8e3s4.willAddChild_hz2iwc_k$(element);
          var tmp = KMutableProperty0();
          var tmp_0 = TextView$_get_content_$ref_4pzcwl(element);
          var tmp_1 = getPropertyCallableRef('content', 0, tmp, tmp_0, TextView$_set_content_$ref_pketfb(element));
          element.invoke_bnq13k_k$(tmp_1, ($this$invoke) => $this$invoke.invoke_r7m7el_k$(value));
          element.onStartup_vrxh3i_k$();
          _this__u8e3s4.addChild_2qpft2_k$(element);
          return Unit_instance;
        };
      }
      view_bqdmap_k$(context, value, module_0) {
        return this.view_9k7335_k$(context, value, module_0);
      }
      cellForm_tanqne_k$(context, value, module_0) {
        return this.form_xfigbc_k$(context, value, module_0);
      }
      cellForm_4mayde_k$(context, value, module_0) {
        return this.cellForm_tanqne_k$(context, value, module_0);
      }
      columnWidth_msmqsd_k$(context, module_0) {
        var tmp0_elvis_lhs = get_averageLength(context);
        var maxLen = tmp0_elvis_lhs == null ? 20 : tmp0_elvis_lhs;
        return coerceAtLeast(coerceAtMost(maxLen, 50) * 0.6, 8.0);
      }
      columnWidth_ilfqwj_k$(context, module_0) {
        return this.columnWidth_msmqsd_k$(context, module_0);
      }
    }
    protoOf($).cellView_2dvin1_k$ = cellView;
    protoOf($).labeledForm_ughtr2_k$ = labeledForm;
    protoOf($).labeledView_aldyvt_k$ = labeledView;
    initMetadataForObject($, 'StringRenderer', VOID, VOID, [Renderer()]);
    StringRendererClass = $;
  }
  return StringRendererClass;
}
var StringRenderer_instance;
function StringRenderer_getInstance() {
  return StringRenderer_instance;
}
var MultilineStringRendererClass;
function MultilineStringRenderer() {
  if (MultilineStringRendererClass === VOID) {
    class $ {
      constructor() {
        this.name_1 = 'Multiline Text';
      }
      get_name_woqyms_k$() {
        return this.name_1;
      }
      priority_splaix_k$(context, module_0) {
        return 2.0;
      }
      priority_yxj3hb_k$(context, module_0) {
        return this.priority_splaix_k$(context, module_0);
      }
      form_xfigbc_k$(context, value, module_0) {
        return (_this__u8e3s4) => {
          // Inline function 'com.lightningkite.kiteui.views.fieldTheme' call
          // Inline function 'com.lightningkite.kiteui.views.direct.textArea' call
          var this_0 = themed(_this__u8e3s4, FieldSemantic_getInstance());
          // Inline function 'com.lightningkite.kiteui.views.write' call
          var element = new (TextArea())(this_0.get_context_h02k06_k$());
          ensureOutermostElement(element);
          this_0.willAddChild_hz2iwc_k$(element);
          element.bind_gesskf_k$(element.content_1, value);
          var tmp0_safe_receiver = get_hint(context);
          if (tmp0_safe_receiver == null)
            null;
          else {
            // Inline function 'kotlin.let' call
            element.set_hint_qdfs9y_k$(tmp0_safe_receiver);
          }
          element.onStartup_vrxh3i_k$();
          this_0.addChild_2qpft2_k$(element);
          return Unit_instance;
        };
      }
      form_gie6yk_k$(context, value, module_0) {
        return this.form_xfigbc_k$(context, value, module_0);
      }
      view_9k7335_k$(context, value, module_0) {
        return (_this__u8e3s4) => {
          // Inline function 'com.lightningkite.kiteui.views.direct.text' call
          // Inline function 'com.lightningkite.kiteui.views.write' call
          var element = new (TextView())(_this__u8e3s4.get_context_h02k06_k$());
          ensureOutermostElement(element);
          _this__u8e3s4.willAddChild_hz2iwc_k$(element);
          var tmp = KMutableProperty0();
          var tmp_0 = TextView$_get_content_$ref_4pzcwl(element);
          var tmp_1 = getPropertyCallableRef('content', 0, tmp, tmp_0, TextView$_set_content_$ref_pketfb(element));
          element.invoke_bnq13k_k$(tmp_1, ($this$invoke) => $this$invoke.invoke_r7m7el_k$(value));
          element.set_wraps_9wisy1_k$(true);
          element.onStartup_vrxh3i_k$();
          _this__u8e3s4.addChild_2qpft2_k$(element);
          return Unit_instance;
        };
      }
      view_bqdmap_k$(context, value, module_0) {
        return this.view_9k7335_k$(context, value, module_0);
      }
      cellView_yqs999_k$(context, value, module_0) {
        return (_this__u8e3s4) => {
          // Inline function 'com.lightningkite.kiteui.views.direct.text' call
          // Inline function 'com.lightningkite.kiteui.views.write' call
          var element = new (TextView())(_this__u8e3s4.get_context_h02k06_k$());
          ensureOutermostElement(element);
          _this__u8e3s4.willAddChild_hz2iwc_k$(element);
          var tmp = KMutableProperty0();
          var tmp_0 = TextView$_get_content_$ref_4pzcwl(element);
          var tmp_1 = getPropertyCallableRef('content', 0, tmp, tmp_0, TextView$_set_content_$ref_pketfb(element));
          element.invoke_bnq13k_k$(tmp_1, ($this$invoke) => substringBefore($this$invoke.invoke_r7m7el_k$(value), _Char___init__impl__6a9atx(10)));
          element.set_wraps_9wisy1_k$(false);
          element.set_ellipsis_rhzl3b_k$(true);
          element.onStartup_vrxh3i_k$();
          _this__u8e3s4.addChild_2qpft2_k$(element);
          return Unit_instance;
        };
      }
      cellView_2dvin1_k$(context, value, module_0) {
        return this.cellView_yqs999_k$(context, value, module_0);
      }
      columnWidth_msmqsd_k$(context, module_0) {
        return 30.0;
      }
      columnWidth_ilfqwj_k$(context, module_0) {
        return this.columnWidth_msmqsd_k$(context, module_0);
      }
    }
    protoOf($).cellForm_4mayde_k$ = cellForm;
    protoOf($).labeledForm_ughtr2_k$ = labeledForm;
    protoOf($).labeledView_aldyvt_k$ = labeledView;
    initMetadataForObject($, 'MultilineStringRenderer', VOID, VOID, [Renderer()]);
    MultilineStringRendererClass = $;
  }
  return MultilineStringRendererClass;
}
var MultilineStringRenderer_instance;
function MultilineStringRenderer_getInstance() {
  return MultilineStringRenderer_instance;
}
function IntRenderer$form$lambda$lambda(it) {
  return it;
}
function IntRenderer$form$lambda$lambda_0(old, new_0) {
  var tmp1_elvis_lhs = new_0 == null ? null : numberToInt(new_0);
  return tmp1_elvis_lhs == null ? old : tmp1_elvis_lhs;
}
var IntRendererClass;
function IntRenderer() {
  if (IntRendererClass === VOID) {
    class $ {
      constructor() {
        this.name_1 = 'Number';
      }
      get_name_woqyms_k$() {
        return this.name_1;
      }
      form_56sy3q_k$(context, value, module_0) {
        return (_this__u8e3s4) => {
          // Inline function 'com.lightningkite.kiteui.views.fieldTheme' call
          // Inline function 'com.lightningkite.kiteui.views.direct.numberInput' call
          var this_0 = themed(_this__u8e3s4, FieldSemantic_getInstance());
          // Inline function 'com.lightningkite.kiteui.views.write' call
          var element = new (NumberInput())(this_0.get_context_h02k06_k$());
          ensureOutermostElement(element);
          this_0.willAddChild_hz2iwc_k$(element);
          element.set_align_ypalx0_k$(Align_End_getInstance());
          var tmp = IntRenderer$form$lambda$lambda;
          element.bind_gesskf_k$(element.content_1, value.lens_u4wb4z_k$(tmp, IntRenderer$form$lambda$lambda_0));
          element.onStartup_vrxh3i_k$();
          this_0.addChild_2qpft2_k$(element);
          return Unit_instance;
        };
      }
      form_gie6yk_k$(context, value, module_0) {
        return this.form_56sy3q_k$(context, value, module_0);
      }
      view_7yvvkr_k$(context, value, module_0) {
        return (_this__u8e3s4) => {
          // Inline function 'com.lightningkite.kiteui.views.direct.text' call
          // Inline function 'com.lightningkite.kiteui.views.write' call
          var element = new (TextView())(_this__u8e3s4.get_context_h02k06_k$());
          ensureOutermostElement(element);
          _this__u8e3s4.willAddChild_hz2iwc_k$(element);
          var tmp = KMutableProperty0();
          var tmp_0 = TextView$_get_content_$ref_4pzcwl(element);
          var tmp_1 = getPropertyCallableRef('content', 0, tmp, tmp_0, TextView$_set_content_$ref_pketfb(element));
          element.invoke_bnq13k_k$(tmp_1, ($this$invoke) => $this$invoke.invoke_r7m7el_k$(value).toString());
          element.onStartup_vrxh3i_k$();
          _this__u8e3s4.addChild_2qpft2_k$(element);
          return Unit_instance;
        };
      }
      view_bqdmap_k$(context, value, module_0) {
        return this.view_7yvvkr_k$(context, value, module_0);
      }
      cellForm_ytsllw_k$(context, value, module_0) {
        return this.form_56sy3q_k$(context, value, module_0);
      }
      cellForm_4mayde_k$(context, value, module_0) {
        return this.cellForm_ytsllw_k$(context, value, module_0);
      }
      columnWidth_30ef47_k$(context, module_0) {
        return 10.0;
      }
      columnWidth_ilfqwj_k$(context, module_0) {
        return this.columnWidth_30ef47_k$(context, module_0);
      }
    }
    protoOf($).priority_yxj3hb_k$ = priority;
    protoOf($).cellView_2dvin1_k$ = cellView;
    protoOf($).labeledForm_ughtr2_k$ = labeledForm;
    protoOf($).labeledView_aldyvt_k$ = labeledView;
    initMetadataForObject($, 'IntRenderer', VOID, VOID, [Renderer()]);
    IntRendererClass = $;
  }
  return IntRendererClass;
}
var IntRenderer_instance;
function IntRenderer_getInstance() {
  return IntRenderer_instance;
}
function NullableIntRenderer$form$lambda$lambda(it) {
  return it == null ? null : it;
}
function NullableIntRenderer$form$lambda$lambda_0(it) {
  return it == null ? null : numberToInt(it);
}
var NullableIntRendererClass;
function NullableIntRenderer() {
  if (NullableIntRendererClass === VOID) {
    class $ {
      constructor() {
        this.name_1 = 'Number';
      }
      get_name_woqyms_k$() {
        return this.name_1;
      }
      form_3gq0eu_k$(context, value, module_0) {
        return (_this__u8e3s4) => {
          // Inline function 'com.lightningkite.kiteui.views.fieldTheme' call
          // Inline function 'com.lightningkite.kiteui.views.direct.numberInput' call
          var this_0 = themed(_this__u8e3s4, FieldSemantic_getInstance());
          // Inline function 'com.lightningkite.kiteui.views.write' call
          var element = new (NumberInput())(this_0.get_context_h02k06_k$());
          ensureOutermostElement(element);
          this_0.willAddChild_hz2iwc_k$(element);
          element.set_align_ypalx0_k$(Align_End_getInstance());
          var tmp = NullableIntRenderer$form$lambda$lambda;
          element.bind_gesskf_k$(element.content_1, value.lens_drj4fu_k$(tmp, NullableIntRenderer$form$lambda$lambda_0));
          element.onStartup_vrxh3i_k$();
          this_0.addChild_2qpft2_k$(element);
          return Unit_instance;
        };
      }
      form_gie6yk_k$(context, value, module_0) {
        return this.form_3gq0eu_k$(context, value, module_0);
      }
      view_6cdsht_k$(context, value, module_0) {
        return (_this__u8e3s4) => {
          // Inline function 'com.lightningkite.kiteui.views.direct.text' call
          // Inline function 'com.lightningkite.kiteui.views.write' call
          var element = new (TextView())(_this__u8e3s4.get_context_h02k06_k$());
          ensureOutermostElement(element);
          _this__u8e3s4.willAddChild_hz2iwc_k$(element);
          var tmp = KMutableProperty0();
          var tmp_0 = TextView$_get_content_$ref_4pzcwl(element);
          var tmp_1 = getPropertyCallableRef('content', 0, tmp, tmp_0, TextView$_set_content_$ref_pketfb(element));
          element.invoke_bnq13k_k$(tmp_1, ($this$invoke) => {
            var tmp0_safe_receiver = $this$invoke.invoke_r7m7el_k$(value);
            var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.toString();
            return tmp1_elvis_lhs == null ? '\u2014' : tmp1_elvis_lhs;
          });
          element.onStartup_vrxh3i_k$();
          _this__u8e3s4.addChild_2qpft2_k$(element);
          return Unit_instance;
        };
      }
      view_bqdmap_k$(context, value, module_0) {
        return this.view_6cdsht_k$(context, value, module_0);
      }
      cellForm_2sag9g_k$(context, value, module_0) {
        return this.form_3gq0eu_k$(context, value, module_0);
      }
      cellForm_4mayde_k$(context, value, module_0) {
        return this.cellForm_2sag9g_k$(context, value, module_0);
      }
      columnWidth_7fbko4_k$(context, module_0) {
        return 10.0;
      }
      columnWidth_ilfqwj_k$(context, module_0) {
        return this.columnWidth_7fbko4_k$(context, module_0);
      }
    }
    protoOf($).priority_yxj3hb_k$ = priority;
    protoOf($).cellView_2dvin1_k$ = cellView;
    protoOf($).labeledForm_ughtr2_k$ = labeledForm;
    protoOf($).labeledView_aldyvt_k$ = labeledView;
    initMetadataForObject($, 'NullableIntRenderer', VOID, VOID, [Renderer()]);
    NullableIntRendererClass = $;
  }
  return NullableIntRendererClass;
}
var NullableIntRenderer_instance;
function NullableIntRenderer_getInstance() {
  return NullableIntRenderer_instance;
}
function LongRenderer$form$lambda$lambda(it) {
  return toNumber(it);
}
function LongRenderer$form$lambda$lambda_0(old, new_0) {
  var tmp1_elvis_lhs = new_0 == null ? null : numberToLong(new_0);
  return tmp1_elvis_lhs == null ? old : tmp1_elvis_lhs;
}
var LongRendererClass;
function LongRenderer() {
  if (LongRendererClass === VOID) {
    class $ {
      constructor() {
        this.name_1 = 'Number';
      }
      get_name_woqyms_k$() {
        return this.name_1;
      }
      form_gksz3k_k$(context, value, module_0) {
        return (_this__u8e3s4) => {
          // Inline function 'com.lightningkite.kiteui.views.fieldTheme' call
          // Inline function 'com.lightningkite.kiteui.views.direct.numberInput' call
          var this_0 = themed(_this__u8e3s4, FieldSemantic_getInstance());
          // Inline function 'com.lightningkite.kiteui.views.write' call
          var element = new (NumberInput())(this_0.get_context_h02k06_k$());
          ensureOutermostElement(element);
          this_0.willAddChild_hz2iwc_k$(element);
          element.set_align_ypalx0_k$(Align_End_getInstance());
          var tmp = LongRenderer$form$lambda$lambda;
          element.bind_gesskf_k$(element.content_1, value.lens_u4wb4z_k$(tmp, LongRenderer$form$lambda$lambda_0));
          element.onStartup_vrxh3i_k$();
          this_0.addChild_2qpft2_k$(element);
          return Unit_instance;
        };
      }
      form_gie6yk_k$(context, value, module_0) {
        return this.form_gksz3k_k$(context, value, module_0);
      }
      view_civr33_k$(context, value, module_0) {
        return (_this__u8e3s4) => {
          // Inline function 'com.lightningkite.kiteui.views.direct.text' call
          // Inline function 'com.lightningkite.kiteui.views.write' call
          var element = new (TextView())(_this__u8e3s4.get_context_h02k06_k$());
          ensureOutermostElement(element);
          _this__u8e3s4.willAddChild_hz2iwc_k$(element);
          var tmp = KMutableProperty0();
          var tmp_0 = TextView$_get_content_$ref_4pzcwl(element);
          var tmp_1 = getPropertyCallableRef('content', 0, tmp, tmp_0, TextView$_set_content_$ref_pketfb(element));
          element.invoke_bnq13k_k$(tmp_1, ($this$invoke) => $this$invoke.invoke_r7m7el_k$(value).toString());
          element.onStartup_vrxh3i_k$();
          _this__u8e3s4.addChild_2qpft2_k$(element);
          return Unit_instance;
        };
      }
      view_bqdmap_k$(context, value, module_0) {
        return this.view_civr33_k$(context, value, module_0);
      }
      cellForm_fwdey6_k$(context, value, module_0) {
        return this.form_gksz3k_k$(context, value, module_0);
      }
      cellForm_4mayde_k$(context, value, module_0) {
        return this.cellForm_fwdey6_k$(context, value, module_0);
      }
      columnWidth_eokdo7_k$(context, module_0) {
        return 12.0;
      }
      columnWidth_ilfqwj_k$(context, module_0) {
        return this.columnWidth_eokdo7_k$(context, module_0);
      }
    }
    protoOf($).priority_yxj3hb_k$ = priority;
    protoOf($).cellView_2dvin1_k$ = cellView;
    protoOf($).labeledForm_ughtr2_k$ = labeledForm;
    protoOf($).labeledView_aldyvt_k$ = labeledView;
    initMetadataForObject($, 'LongRenderer', VOID, VOID, [Renderer()]);
    LongRendererClass = $;
  }
  return LongRendererClass;
}
var LongRenderer_instance;
function LongRenderer_getInstance() {
  return LongRenderer_instance;
}
function NullableLongRenderer$form$lambda$lambda(it) {
  return it == null ? null : toNumber(it);
}
function NullableLongRenderer$form$lambda$lambda_0(it) {
  return it == null ? null : numberToLong(it);
}
var NullableLongRendererClass;
function NullableLongRenderer() {
  if (NullableLongRendererClass === VOID) {
    class $ {
      constructor() {
        this.name_1 = 'Number';
      }
      get_name_woqyms_k$() {
        return this.name_1;
      }
      form_gftg7a_k$(context, value, module_0) {
        return (_this__u8e3s4) => {
          // Inline function 'com.lightningkite.kiteui.views.fieldTheme' call
          // Inline function 'com.lightningkite.kiteui.views.direct.numberInput' call
          var this_0 = themed(_this__u8e3s4, FieldSemantic_getInstance());
          // Inline function 'com.lightningkite.kiteui.views.write' call
          var element = new (NumberInput())(this_0.get_context_h02k06_k$());
          ensureOutermostElement(element);
          this_0.willAddChild_hz2iwc_k$(element);
          element.set_align_ypalx0_k$(Align_End_getInstance());
          var tmp = NullableLongRenderer$form$lambda$lambda;
          element.bind_gesskf_k$(element.content_1, value.lens_drj4fu_k$(tmp, NullableLongRenderer$form$lambda$lambda_0));
          element.onStartup_vrxh3i_k$();
          this_0.addChild_2qpft2_k$(element);
          return Unit_instance;
        };
      }
      form_gie6yk_k$(context, value, module_0) {
        return this.form_gftg7a_k$(context, value, module_0);
      }
      view_xfr1s1_k$(context, value, module_0) {
        return (_this__u8e3s4) => {
          // Inline function 'com.lightningkite.kiteui.views.direct.text' call
          // Inline function 'com.lightningkite.kiteui.views.write' call
          var element = new (TextView())(_this__u8e3s4.get_context_h02k06_k$());
          ensureOutermostElement(element);
          _this__u8e3s4.willAddChild_hz2iwc_k$(element);
          var tmp = KMutableProperty0();
          var tmp_0 = TextView$_get_content_$ref_4pzcwl(element);
          var tmp_1 = getPropertyCallableRef('content', 0, tmp, tmp_0, TextView$_set_content_$ref_pketfb(element));
          element.invoke_bnq13k_k$(tmp_1, ($this$invoke) => {
            var tmp0_safe_receiver = $this$invoke.invoke_r7m7el_k$(value);
            var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.toString();
            return tmp1_elvis_lhs == null ? '\u2014' : tmp1_elvis_lhs;
          });
          element.onStartup_vrxh3i_k$();
          _this__u8e3s4.addChild_2qpft2_k$(element);
          return Unit_instance;
        };
      }
      view_bqdmap_k$(context, value, module_0) {
        return this.view_xfr1s1_k$(context, value, module_0);
      }
      cellForm_3ih24k_k$(context, value, module_0) {
        return this.form_gftg7a_k$(context, value, module_0);
      }
      cellForm_4mayde_k$(context, value, module_0) {
        return this.cellForm_3ih24k_k$(context, value, module_0);
      }
      columnWidth_e2w20k_k$(context, module_0) {
        return 12.0;
      }
      columnWidth_ilfqwj_k$(context, module_0) {
        return this.columnWidth_e2w20k_k$(context, module_0);
      }
    }
    protoOf($).priority_yxj3hb_k$ = priority;
    protoOf($).cellView_2dvin1_k$ = cellView;
    protoOf($).labeledForm_ughtr2_k$ = labeledForm;
    protoOf($).labeledView_aldyvt_k$ = labeledView;
    initMetadataForObject($, 'NullableLongRenderer', VOID, VOID, [Renderer()]);
    NullableLongRendererClass = $;
  }
  return NullableLongRendererClass;
}
var NullableLongRenderer_instance;
function NullableLongRenderer_getInstance() {
  return NullableLongRenderer_instance;
}
function DoubleRenderer$form$lambda$lambda(it) {
  return it;
}
function DoubleRenderer$form$lambda$lambda_0(old, new_0) {
  return new_0 == null ? old : new_0;
}
var DoubleRendererClass;
function DoubleRenderer() {
  if (DoubleRendererClass === VOID) {
    class $ {
      constructor() {
        this.name_1 = 'Decimal';
      }
      get_name_woqyms_k$() {
        return this.name_1;
      }
      form_jb96y0_k$(context, value, module_0) {
        return (_this__u8e3s4) => {
          // Inline function 'com.lightningkite.kiteui.views.fieldTheme' call
          // Inline function 'com.lightningkite.kiteui.views.direct.numberInput' call
          var this_0 = themed(_this__u8e3s4, FieldSemantic_getInstance());
          // Inline function 'com.lightningkite.kiteui.views.write' call
          var element = new (NumberInput())(this_0.get_context_h02k06_k$());
          ensureOutermostElement(element);
          this_0.willAddChild_hz2iwc_k$(element);
          element.set_align_ypalx0_k$(Align_End_getInstance());
          var tmp = DoubleRenderer$form$lambda$lambda;
          element.bind_gesskf_k$(element.content_1, value.lens_u4wb4z_k$(tmp, DoubleRenderer$form$lambda$lambda_0));
          element.onStartup_vrxh3i_k$();
          this_0.addChild_2qpft2_k$(element);
          return Unit_instance;
        };
      }
      form_gie6yk_k$(context, value, module_0) {
        return this.form_jb96y0_k$(context, value, module_0);
      }
      view_yoqkpt_k$(context, value, module_0) {
        return (_this__u8e3s4) => {
          // Inline function 'com.lightningkite.kiteui.views.direct.text' call
          // Inline function 'com.lightningkite.kiteui.views.write' call
          var element = new (TextView())(_this__u8e3s4.get_context_h02k06_k$());
          ensureOutermostElement(element);
          _this__u8e3s4.willAddChild_hz2iwc_k$(element);
          var tmp = KMutableProperty0();
          var tmp_0 = TextView$_get_content_$ref_4pzcwl(element);
          var tmp_1 = getPropertyCallableRef('content', 0, tmp, tmp_0, TextView$_set_content_$ref_pketfb(element));
          element.invoke_bnq13k_k$(tmp_1, ($this$invoke) => $this$invoke.invoke_r7m7el_k$(value).toString());
          element.onStartup_vrxh3i_k$();
          _this__u8e3s4.addChild_2qpft2_k$(element);
          return Unit_instance;
        };
      }
      view_bqdmap_k$(context, value, module_0) {
        return this.view_yoqkpt_k$(context, value, module_0);
      }
      cellForm_b0bbxm_k$(context, value, module_0) {
        return this.form_jb96y0_k$(context, value, module_0);
      }
      cellForm_4mayde_k$(context, value, module_0) {
        return this.cellForm_b0bbxm_k$(context, value, module_0);
      }
      columnWidth_ikwt2b_k$(context, module_0) {
        return 12.0;
      }
      columnWidth_ilfqwj_k$(context, module_0) {
        return this.columnWidth_ikwt2b_k$(context, module_0);
      }
    }
    protoOf($).priority_yxj3hb_k$ = priority;
    protoOf($).cellView_2dvin1_k$ = cellView;
    protoOf($).labeledForm_ughtr2_k$ = labeledForm;
    protoOf($).labeledView_aldyvt_k$ = labeledView;
    initMetadataForObject($, 'DoubleRenderer', VOID, VOID, [Renderer()]);
    DoubleRendererClass = $;
  }
  return DoubleRendererClass;
}
var DoubleRenderer_instance;
function DoubleRenderer_getInstance() {
  return DoubleRenderer_instance;
}
var NullableDoubleRendererClass;
function NullableDoubleRenderer() {
  if (NullableDoubleRendererClass === VOID) {
    class $ {
      constructor() {
        this.name_1 = 'Decimal';
      }
      get_name_woqyms_k$() {
        return this.name_1;
      }
      form_278kw6_k$(context, value, module_0) {
        return (_this__u8e3s4) => {
          // Inline function 'com.lightningkite.kiteui.views.fieldTheme' call
          // Inline function 'com.lightningkite.kiteui.views.direct.numberInput' call
          var this_0 = themed(_this__u8e3s4, FieldSemantic_getInstance());
          // Inline function 'com.lightningkite.kiteui.views.write' call
          var element = new (NumberInput())(this_0.get_context_h02k06_k$());
          ensureOutermostElement(element);
          this_0.willAddChild_hz2iwc_k$(element);
          element.set_align_ypalx0_k$(Align_End_getInstance());
          element.bind_gesskf_k$(element.content_1, value);
          element.onStartup_vrxh3i_k$();
          this_0.addChild_2qpft2_k$(element);
          return Unit_instance;
        };
      }
      form_gie6yk_k$(context, value, module_0) {
        return this.form_278kw6_k$(context, value, module_0);
      }
      view_nzjch3_k$(context, value, module_0) {
        return (_this__u8e3s4) => {
          // Inline function 'com.lightningkite.kiteui.views.direct.text' call
          // Inline function 'com.lightningkite.kiteui.views.write' call
          var element = new (TextView())(_this__u8e3s4.get_context_h02k06_k$());
          ensureOutermostElement(element);
          _this__u8e3s4.willAddChild_hz2iwc_k$(element);
          var tmp = KMutableProperty0();
          var tmp_0 = TextView$_get_content_$ref_4pzcwl(element);
          var tmp_1 = getPropertyCallableRef('content', 0, tmp, tmp_0, TextView$_set_content_$ref_pketfb(element));
          element.invoke_bnq13k_k$(tmp_1, ($this$invoke) => {
            var tmp0_safe_receiver = $this$invoke.invoke_r7m7el_k$(value);
            var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.toString();
            return tmp1_elvis_lhs == null ? '\u2014' : tmp1_elvis_lhs;
          });
          element.onStartup_vrxh3i_k$();
          _this__u8e3s4.addChild_2qpft2_k$(element);
          return Unit_instance;
        };
      }
      view_bqdmap_k$(context, value, module_0) {
        return this.view_nzjch3_k$(context, value, module_0);
      }
      cellForm_qsj91g_k$(context, value, module_0) {
        return this.form_278kw6_k$(context, value, module_0);
      }
      cellForm_4mayde_k$(context, value, module_0) {
        return this.cellForm_qsj91g_k$(context, value, module_0);
      }
      columnWidth_74mss8_k$(context, module_0) {
        return 12.0;
      }
      columnWidth_ilfqwj_k$(context, module_0) {
        return this.columnWidth_74mss8_k$(context, module_0);
      }
    }
    protoOf($).priority_yxj3hb_k$ = priority;
    protoOf($).cellView_2dvin1_k$ = cellView;
    protoOf($).labeledForm_ughtr2_k$ = labeledForm;
    protoOf($).labeledView_aldyvt_k$ = labeledView;
    initMetadataForObject($, 'NullableDoubleRenderer', VOID, VOID, [Renderer()]);
    NullableDoubleRendererClass = $;
  }
  return NullableDoubleRendererClass;
}
var NullableDoubleRenderer_instance;
function NullableDoubleRenderer_getInstance() {
  return NullableDoubleRenderer_instance;
}
//region block: init
BooleanRenderer_instance = new (BooleanRenderer())();
NullableBooleanRenderer_instance = new (NullableBooleanRenderer())();
StringRenderer_instance = new (StringRenderer())();
MultilineStringRenderer_instance = new (MultilineStringRenderer())();
IntRenderer_instance = new (IntRenderer())();
NullableIntRenderer_instance = new (NullableIntRenderer())();
LongRenderer_instance = new (LongRenderer())();
NullableLongRenderer_instance = new (NullableLongRenderer())();
DoubleRenderer_instance = new (DoubleRenderer())();
NullableDoubleRenderer_instance = new (NullableDoubleRenderer())();
//endregion
//region block: exports
export {
  registerPrimitives as registerPrimitives5bvy9r84uuq6,
};
//endregion

//# sourceMappingURL=PrimitiveRenderers.mjs.map
